<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeSurveyStatus
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeSurveyStatusProps } from '../types/interfaces'

import { useBadgeSurveyStatus } from '../composables/use-badge-survey-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeSurveyStatus',
})

const props = defineProps<BadgeSurveyStatusProps>()

const {
  color,
  text,
} = useBadgeSurveyStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
